import React from 'react';
import { Container } from '../components.js';

class AverageAmount extends React.Component {

	constructor(props) {
		super(props);

		this.getAverages = this.getAverages.bind(this);

		this.state = { averages : {data :{}, dataError: false}};
	}

	componentDidMount() {
		
		if(this.state.averages.data !== null && Object.keys(this.state.averages.data).length === 0 && this.state.averages.dataError === false) {
			this.getAverages();
		}
	}

	getAverages() {
		
		var component = this;

		var callback = function(response) {
			if(response.code === 200) {
				if(response.detail !== "Report generated") {
						component.setState({averages: { data : {}, dataError : response.detail}});
				}
				else {
					component.setState({averages: { data : response.data, dataError : response.detail}});
				}
			}
			else {
				component.setState({averages: { data : {}, dataError : response.detail}});
			}
		};
		
		window._fiSponsor.getGoalsAverages(callback);
	}

	render() {
		const avgGoalContainerSize = {
			width: (this.props.size) ? this.props.size.width : '22vmin',
			height: (this.props.size) ? this.props.size.height : '27vmin'
		};

	  	const amountBoxContent = (this.state.averages && this.state.averages.data && Object.keys(this.state.averages.data).length ) ? (<div className="Data-Div"><img className="Data-Icon" src="/images/avg_goal_amt.png" alt="Bullseye Icon" /><br />{'$' + this.state.averages.data.average_amount.toString()} </div> ) : (this.state.averages.dataError) ? 'Unable to get average data' : 'Loading...';

  		return (
      		<Container key='avgGoalAmount' moreClass={"App-ChartsLeft " + this.props.addClass} 
      		moreTitleClass={"App-ChartsTitle"} titles={[{'label' : 'Average Goal Amount', 'onClick' : ''}]} 
      		contents={amountBoxContent} size={avgGoalContainerSize} onclick={this.props.onclick} bgcolor="rgb(100, 160, 67)" />
  		);
	}
}

export default AverageAmount;








